"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.languageMap = exports.noPay = exports.inStorePayment = exports.PICKUP = exports.DELIVERY = exports.PaymentProvider = exports.PaymentProviders = exports.optionIds = exports.cheeseCodesForOptions = exports.disableExtraForToppings = exports.locales = exports.getTenDigitPhoneValue = exports.getTenDigitPhoneFormatted = exports.phonePatterns = exports.delivery = void 0;

var _replace2 = _interopRequireDefault(require("lodash/replace"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var delivery = {
  action: {
    tip: 'DeliveryTip',
    estimate: 'DeliveryEstimate',
    newEstimate: 'DeliveryNewEstimate',
    fees: 'DeliveryFees',
    promo: 'DeliveryPromo'
  }
};
exports.delivery = delivery;
var phonePatterns = {
  replace: /[\D]/g,
  format: /(\d{3})(\d{3})(\d{4})/
};
exports.phonePatterns = phonePatterns;

var getTenDigitPhoneFormatted = function getTenDigitPhoneFormatted(phoneNumber) {
  return phoneNumber ? (0, _replace2["default"])(phoneNumber, phonePatterns.format, '($1) $2-$3') : '';
};

exports.getTenDigitPhoneFormatted = getTenDigitPhoneFormatted;

var getTenDigitPhoneValue = function getTenDigitPhoneValue(phoneNumber) {
  return phoneNumber ? (0, _replace2["default"])(phoneNumber, phonePatterns.replace, '') : '';
};

exports.getTenDigitPhoneValue = getTenDigitPhoneValue;
var locales = {
  mx: {
    es: 'es-mx'
  },
  us: {
    en: 'en-us',
    es: 'es-us'
  },
  ca: {
    en: 'en-ca',
    fr: 'fr-ca'
  },
  gt: {
    es: 'es-gt'
  }
};
exports.locales = locales;
var disableExtraForToppings = ['TOP-ECHS', 'TOP-CAECHS', 'TOP-MXECHS', 'TOP-GTECHS'];
exports.disableExtraForToppings = disableExtraForToppings;
var cheeseCodesForOptions = ['TOP-ECHS', 'TOP-MXECHS', 'TOP-CAECHS', 'TOP-GTECHS'];
exports.cheeseCodesForOptions = cheeseCodesForOptions;
var optionIds = {
  cheese: 'C',
  sauce: 'S',
  bake: 'B',
  cutOption: 'CO'
};
exports.optionIds = optionIds;
var PaymentProviders = {
  mx: 'CYBERSOURCE',
  us: 'VANTIV',
  ca: 'BAMBORA'
};
exports.PaymentProviders = PaymentProviders;
var PaymentProvider = {
  CYBERSOURCE: 'CYBERSOURCE',
  VANTIV: 'VANTIV',
  BAMBORA: 'BAMBORA'
};
exports.PaymentProvider = PaymentProvider;
var DELIVERY = 'delivery';
exports.DELIVERY = DELIVERY;
var PICKUP = 'pickup';
exports.PICKUP = PICKUP;
var inStorePayment = 'inStorePayment';
exports.inStorePayment = inStorePayment;
var noPay = 'NoPay';
exports.noPay = noPay;
var languageMap = {
  'en-us': {
    country: 'us',
    locale: 'en-us'
  },
  'es-us': {
    country: 'us',
    locale: 'es-419'
  },
  'fr-ca': {
    country: 'ca',
    locale: 'fr-ca'
  },
  'en-ca': {
    country: 'ca',
    locale: 'en-us'
  },
  'es-mx': {
    country: 'mx',
    locale: 'es-419'
  },
  'es-gt': {
    country: 'gt',
    locale: 'es-419'
  }
};
exports.languageMap = languageMap;